import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useNav from "core/hooks/useNav";
import api from "api";
import type { PartnerConfigUpdate } from "api/models/partner";

import { useStoreWelcome } from "./store";


export const query = {
	config: (partnerId: string) => ({
		queryKey: ["partner-config", partnerId],
		queryFn: () => api.partner.config.get(Number(partnerId)),
		enabled: Boolean(partnerId)
	})
};

export const articlePreview = {
	"id": 1,
	"tokens": 1,
	"featured": true,
	"title": "Yellow Labrador Retrievers: America's Beloved Companion",
	"description": "Yellow Labrador Retrievers are one of the most iconic and beloved dog breeds in the United States and around the world. With their warm, golden coats, soulful eyes, and famously friendly demeanor, these dogs have earned a place not just in homes but also in the hearts of millions. Whether serving as",
	"url": "https://thebellevuetribune.com/yellow-labrador-retrievers-americas-beloved-companion/",
	"thumbUrl": "https://subly.ink/partner/C1K2lu84PQr0TB8B/thumb_LI4W4yKs2b7rpeGC.jpg",
	"publishedOn": "2025-07-23T00:25:11Z",
	"partner": {
		"name": "The Bellevue Tribune",
		"logo": {
			"light": "",
			"dark": ""
		}
	}
};

export const useQueryCms = () => {
	return useQuery({
		queryKey: ["partner-cms"],
		queryFn: () => api.partner.getAllCms(),
		select: (data) => data.map(cms => ({ value: cms.id.toString(), label: cms.name }))
	});
};

export const useQueryPaywall = (cmsId?: string) => {
	return useQuery({
		queryKey: ["partner-paywall", cmsId],
		queryFn: () => api.partner.getPaywalls(cmsId!),
		select: (data) => data.map(paywall => ({ value: paywall.id.toString(), label: paywall.name })),
		enabled: Boolean(cmsId)
	});
};

export const useQueryConfig = (partnerId: string) => useQuery(query.config(partnerId));

export const useMutateConfig = () => {
	const nav = useNav();
	const queryClient = useQueryClient();
	const { setStep } = useStoreWelcome();

	return useMutation({
		mutationFn: ({ partnerId, payload }: { partnerId: string; payload: PartnerConfigUpdate }) =>
			api.partner.config.update(Number(partnerId), payload),
		onSuccess: (updated, { partnerId, payload: { step } }) => {
			queryClient.setQueryData(["partner-config", partnerId], updated);
			if (!step) nav.back();
			else setStep(step);
		}
	});
};